
export const testPageContent = {
  accordionReact:{
    items: [
      {
        title: 'Lorem Ipsum',
        description: [
          'Tenetur ullam rerum ad iusto possimus sequi mollitia dolore sunt quam praesentium. Tenetur ullam rerum ad iusto possimus sequi mollitia dolore sunt quam praesentium.Tenetur ullam rerum ad iusto possimus sequi mollitia dolore sunt quam praesentium.',
        ],
        icon: ["+", "-"]
      },
      {
        title: 'Dignissimos sequi architecto?',
        description: ['Aperiam ab atque incidunt dolores ullam est, earum ipsa recusandae velit cumque. Aperiam ab atque incidunt dolores ullam est, earum ipsa recusandae velit cumque.'],
        icon: ["+", "-"]
      },
      // {
      //   title: 'Voluptas praesentium facere?',
      //   description: ['Blanditiis aliquid adipisci quisquam reiciendis voluptates itaque.'],
      //   icon: ["+", "-"]
      // },
    ]
  }
}